import { render, staticRenderFns } from "./Step0.vue?vue&type=template&id=61b7fb5a&scoped=true&"
import script from "./Step0.vue?vue&type=script&lang=js&"
export * from "./Step0.vue?vue&type=script&lang=js&"
import style0 from "./Step0.vue?vue&type=style&index=0&id=61b7fb5a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b7fb5a",
  null
  
)

export default component.exports